'use client';

import Image from 'next/image';
import type { TourFeedbackPrompt } from '@repo/utils';
import {
  formatCurrency,
  getTourFeedbackBedsBaths,
  getTourFeedbackImageUrl,
  getTourFeedbackPriceDisplay,
} from '@repo/utils';

const PLACEHOLDER_IMAGE = '/listing-card-placeholder.png';

type TourFeedbackPropertyCardProps = {
  prompt: TourFeedbackPrompt;
};

export function TourFeedbackPropertyCard({ prompt }: TourFeedbackPropertyCardProps) {
  const { hasActiveListing, showTwoPrices, net, gross } = getTourFeedbackPriceDisplay(prompt.unit);
  const bedsBaths = getTourFeedbackBedsBaths(prompt.unit);
  const displayNet = net ?? '';
  const displayGross = gross ?? '';
  const imageUrl = getTourFeedbackImageUrl(prompt.unit) ?? PLACEHOLDER_IMAGE;

  return (
    <div className="flex gap-4">
      <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-xl bg-secondary">
        <Image
          src={imageUrl}
          alt={prompt.unit.displayAddress}
          fill
          className="object-cover"
          sizes="64px"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
        <p className="text-body-2-high text-primary">{prompt.unit.displayAddress}</p>
        {bedsBaths ? <p className="truncate text-caption text-secondary">{bedsBaths}</p> : null}
        {hasActiveListing ? (
          <div className="flex items-center gap-1.5">
            {showTwoPrices ? (
              <span className="text-caption text-secondary line-through">
                {formatCurrency(displayGross)}
              </span>
            ) : null}
            <span className="text-body-1-high text-primary">
              {formatCurrency(displayNet || displayGross)}
            </span>
          </div>
        ) : (
          <p className="text-caption text-secondary">Closed</p>
        )}
      </div>
    </div>
  );
}
